const config = {

  Auth: {

      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: "eu-west-1:f64f5198-e35c-43b3-92ea-c1836d48b0b9",

      // REQUIRED - Amazon Cognito Region
      // region: 'eu-central-1',
      region: 'eu-west-1',

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'eu-west-1_fVLqxX7ud',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '3dq31g5893j0v8omlopb6phih4',

      // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
      mandatorySignIn: false,

      // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
      authenticationFlowType: 'USER_SRP_AUTH'   // SRP = Secure Remote Protocol

   }

};

export default config;

/******************************************************************************************

COGNITO USER POOL    [creato da admin in eu-central-1]

  Nome del pool: facegate-userpool

  How do you want your end users to sign in?    username

  Required attributes:  email, name
  Custom attributes:    custom:collection

  Policies:
            - 8 char simple password
            - Do you want to allow users to sign themselves up?   YES
            - Expiration: 2

  MFA and verifications
     - MFA off
     - Verification:     Email YES     Phone number NO
     - Role:  facegateuserpool-SMS-Role

  Message customizations: default
  Tags: owner Giulio Giandonato , creator Giulio Giandonato , prj FaceGate
  Devices: no

  App client N.1
   - App client name:      FaceGate App Client
   - Refresh token expiration: 30 (default)
   - NB: select Enable sign-in API for server-based authentication (ADMIN_NO_SRP_AUTH) YES
   - Generate client secret:    NO! (non supportato in JavaScript SDK)
   Read & write permissions: abilitare tutto

   =====>  App client id  =  6bn59utaau5e0ck9jp48ljkeb6        <======  USO QUESTA !!!

  Triggers: nessuno

  Pool created successfully!

  =======> Pool ID = eu-central-1_zDzjaDgta                    <======  USO QUESTA !!!

  =======> Identity Pool ID = eu-central-1:d21fb385-b9a2-4091-b99c-837c3af60a05 , facegate_identitypool

-------------------------------------------------------------------------------------

  Users:

   softdue

*****************************************************************************************/
